import moment from 'moment'
import 'moment-timezone'
import _ from 'lodash'
import { CHILDREN_TYPE, TIMEZONE } from 'constants/index'

export const formatHelper = {
  formatDateTime,
  formatError,
  summaryError,
  formatBookingData,
  convertDateToTimestamp,
  formatCurrency,
  formatPrice,
  formatTimeSchedule,
  formatChildrenType,
  formatComplaintData,
  getCountDownRemainingTime,
  getOrdinal
}

function convertDateToTimestamp (date) {
  return Math.round(date / 1000)
}

function formatError (errorObject) {
  if (!errorObject) return ''
  if (errorObject.message) {
    return errorObject.message
  }
  return errorObject[0]?.message || ''
}

function summaryError(errorObject) {
  const result = []
  try {
    if (errorObject.message) {
      result.push(errorObject.message)
      return result
    }
    errorObject.map((item) => {
      result.push(item.message)
    })
    return result
  } catch (error) {
    return result
  }
}

function formatDateTime(timeStamp, format = 'H[h]mm, DD.MM.YYYY', locale) {
  if (locale) {
    moment.locale(locale)
  }
  const dateTime = moment(timeStamp * 1000)
  return dateTime.format(format)
}

function formatBookingData (bookings) {
  const formatData = []
  const bookingGrouped = _.groupBy(_.orderBy(bookings, ['begin_at'], ['desc']), booking => formatDateTime(booking.begin_at, 'ddd, Do MMM'))
  Object.keys(bookingGrouped).map(key => {
    formatData.push({
      date: key,
      bookings: _.orderBy(bookingGrouped[key], ['begin_at'], ['asc'])
    })
  })
  return formatData
}

function formatComplaintData (complaints) {
  const formatData = []
  const complaintGrouped = _.groupBy(_.orderBy(complaints, ['created_at'], ['desc']), complaint => formatDateTime(complaint.created_at, 'ddd, Do MMM'))
  Object.keys(complaintGrouped).map(key => {
    formatData.push({
      date: key,
      complaints: _.orderBy(complaintGrouped[key], ['created_at'], ['desc'])
    })
  })
  return formatData
}

function formatPrice (number, separate = ',', symbol = '') {
  if (!number) {
    return 0 + symbol
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separate) + symbol
}

function formatCurrency (currency) {
  switch (currency) {
    case 'USD':
      return '$'
    case 'VND':
      return '₫'
    case 'THB':
      return '฿'
    case 'INR':
      return 'IDR'
    default:
      return currency
  }
}

function formatTimeSchedule (times, timeZone) {
  let results = []
  times.forEach(time => {
    const today = moment().tz(TIMEZONE.HCM)
    const timeName = time.name.split('-')[0].trim()
    today.set({
      hours: timeName.split(':')[0],
      minutes: timeName.split(':')[1]
    })
    results.push({
      id: parseInt(time.id),
      name: today.tz(timeZone).format('HH:mm')
    })
  })
  results = _.orderBy(results, ['name'], ['asc'])
  return results
}

function getOrdinal (n) {
  if(n <=0 ) return 0
  
  let ord = 'th'

  if (n % 10 == 1 && n % 100 != 11) {
    ord = 'st'
  } else if (n % 10 == 2 && n % 100 != 12) {
    ord = 'nd'
  } else if (n % 10 == 3 && n % 100 != 13) {
    ord = 'rd'
  }

  return `${n}${ord}`
}

function formatChildrenType (childrenType) {
  switch (childrenType) {
    case CHILDREN_TYPE.KID:
      return 'KID'
    case CHILDREN_TYPE.ADULT:
      return 'ADULT'
    default:
      return ''
  }
}

function getCountDownRemainingTime(timeStamp) {
  const dateFuture = new Date(timeStamp * 1000)
  const dateNow = new Date()
  const seconds = Math.floor((dateFuture - dateNow) / 1000)
  return seconds
}
